import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function LegalFooterContactUs() {
  return (
    <Box p={2} gap={1} display="flex" flexDirection={{ xs: "column", sm: "row" }} justifyContent="space-around" alignItems="center" bgcolor={"#EDEDED"}>
      <Box>
        <Typography variant="caption" sx={{ fontSize: "11px", color: `${PureLightThemeCaaS.colors.alpha.black[100]}` }}>
          Property of RotoGPT, LLC, Company 2025 - All Rights Reserved.
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="center" gap={2}>
        <Typography
          variant="caption"
          component={Link}
          to="/privacy-policy"
          sx={{ textDecoration: "underline", cursor: "pointer", fontSize: "11px", color: `${PureLightThemeCaaS.colors.alpha.black[100]}` }}
        >
          Privacy Policy
        </Typography>
        <Typography
          variant="caption"
          component={Link}
          to="/terms-conditions"
          sx={{ textDecoration: "underline", cursor: "pointer", fontSize: "11px", color: `${PureLightThemeCaaS.colors.alpha.black[100]}` }}
        >
          Terms and Conditions
        </Typography>
      </Box>
    </Box>
  );
}

export default LegalFooterContactUs;
